import * as patterns from './main';
import { Registry } from '../registry';
export var Background;
(function (Background) {
    Background.presets = patterns;
    Background.registry = Registry.create({
        type: 'background pattern',
    });
    Background.registry.register(Background.presets, true);
})(Background || (Background = {}));
//# sourceMappingURL=index.js.map